module.exports = __webpack_public_path__ + "img/img4.706270f8.svg";